// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__14N_o","col":"styles_col__2gfFz"};